import React from 'react';

import { Paragraph, Wrap } from '@leafwell/components';
import { useMatchMedia } from 'hooks/useMatchMedia';

import AlphabetList from './alphabet-list';

export type AlphabeticalGridItem = {
  slug: string;
  title: string;
  link: string;
};

export type AlphabeticalGridData = {
  [index: string]: AlphabeticalGridItem[];
};

type AlphabeticalGridListProps = {
  exploreLabel?: string;
  showNumbersFilter?: boolean;
  className?: string;
  data: AlphabeticalGridData;
  onChangeLetter?(letter: string): void;
};

const AlphabeticalGridList: React.FC<AlphabeticalGridListProps> = ({
  data = {},
  showNumbersFilter,
  exploreLabel,
  className,
  onChangeLetter,
}) => {
  const [isMediumScreen] = useMatchMedia(['(min-width: 768px)'], [true]);

  return (
    <Wrap className={['!gap-y-1', className].join(' ')}>
      {exploreLabel && (
        <Paragraph className="mb-4" {...{ size: 'xsmall' }}>
          {exploreLabel}
        </Paragraph>
      )}
      <div className="sticky top-[130px] md:top-[68px] xl:top-[100px] z-1 overflow-hidden">
        <AlphabetList
          useHash
          letterNumbers={Object.keys(data).filter(Number)}
          showNumbersFilter={showNumbersFilter}
          onChangeLetter={onChangeLetter}
        />
      </div>
      {Object.keys(data).map(key => {
        const items = data[key];

        const listInlineStyle = !isMediumScreen
          ? {}
          : {
              gridTemplateRows: `repeat(${Math.ceil(
                items?.length / 3,
              )}, 0.5fr)`,
            };
        return (
          <div
            id={key.toLowerCase()}
            key={key}
            className="pb-6 [&:not(:last-child)]:border-b-[1px] scroll-mt-[220px] md:scroll-mt-[190px] "
          >
            <h3 className="text-2xl mt-4 font-medium">{key}</h3>
            <ul
              className="grid md:grid-cols-3 md:grid-flow-col gap-4 mt-4"
              style={listInlineStyle}
            >
              {items?.map(({ slug, link, title }) => {
                return (
                  <li key={slug} className="rounded-md">
                    <a href={link} className="hover:text-lilac-500">
                      {title}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </Wrap>
  );
};

export default AlphabeticalGridList;
